import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const StaffDetails = () => {
    const homeMenu = [
        { label: "Vision", link: "/about" },
        {
            label: "Management", link: "", subMenu: [
                { label: "Director-Principal's Message", link: "/PrincipalMessage" },
                { label: "Leadership Team", link: "/leadershipTeam" },
                { label: "Patron’s Message", link: "/patrons" },
                { label: "Advisory Board", link: "/advisoryBoard" },
            ]
        },

        { label: "International Collaborations", link: "/partnership" },
        { label: "Awards & Achievements", link: "/awardsAcheivements" },
        { label: "Faculty", link: "/faculty" },
        { label: "Staff Details", link: "/staffDetails" },
        { label: "School Strength ", link: "/schoolStrength" },
        { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/staff.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Staff Details" breadEnd="Staff Details" breadMid="Staff Details" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div class="table-responsive">

                                <div class="advertisementspress advertisementsyr2019">
                                    <div class="table">
                                        <table border="1" width="100%">
                                            <tbody><tr>
                                                <th>S.No.</th>
                                                <th>Name</th>
                                                <th>Educational Qualification</th>
                                            </tr>
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aarti </td>
                                                    <td> B.Com./B.Ed./M. Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Aashima Bhatia </td>
                                                    <td> B.A., B. Ed., Dip. B2 Dele. </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Aditya Vashist </td>
                                                    <td> B. Tech, M. Tech, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Aishwarya Gupta </td>
                                                    <td> BA, MA, B.Ed. (Pursuing), B1, B2 in spanish </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Ajit Singh </td>
                                                    <td> B.P.ED.,MP.ED. </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> Akansha Rathi </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> Amber Arora </td>
                                                    <td> BCA/BP.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 8 </td>
                                                    <td> Anchal Bahl </td>
                                                    <td> B.A(Eng), M.A(Eng), B.ED Pursuing), B1 in French, Advanced
                                                        Diploma in French </td>
                                                </tr>
                                                <tr>
                                                    <td> 9 </td>
                                                    <td> Andrea Osta </td>
                                                    <td> B.A.(Eng), M.A.(Eng), B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 10 </td>
                                                    <td> Anil Kumar </td>
                                                    <td> B.P.S.E., B.P.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 11 </td>
                                                    <td> Anjali Bhandari </td>
                                                    <td> B.Com., B.A., M.Com., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 12 </td>
                                                    <td> Anjali Dewan </td>
                                                    <td> B.A.,Dip. in Kathak, Sr. Dip. in Vocal </td>
                                                </tr>
                                                <tr>
                                                    <td> 13 </td>
                                                    <td> Anjali Popli </td>
                                                    <td> B.Sc.(Bot, Zoo&amp;Geo), M.Sc.(Bot), B.Ed., NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 14 </td>
                                                    <td> Ankit Singh </td>
                                                    <td> BA, BP.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 15 </td>
                                                    <td> Ankita </td>
                                                    <td> B.Tech, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 16 </td>
                                                    <td> Anoop Singh </td>
                                                    <td> B.Sc, B.P.Ed, NIS certificate </td>
                                                </tr>
                                                <tr>
                                                    <td> 17 </td>
                                                    <td> Anubha Mehta </td>
                                                    <td> B.Tech/(Non-B.Ed.) </td>
                                                </tr>
                                                <tr>
                                                    <td> 18 </td>
                                                    <td> Anupam Gupta </td>
                                                    <td> B.Com(H), M.Com, B.Ed, PGDBM, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 19 </td>
                                                    <td> Anwesha Mukhopadhyay </td>
                                                    <td> B.Com, NTT, B.Ed , MA (Socio) </td>
                                                </tr>
                                                <tr>
                                                    <td> 20 </td>
                                                    <td> Ashima Yadav </td>
                                                    <td> B.Tech., B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 21 </td>
                                                    <td> Ashmita Singh </td>
                                                    <td> B.A., M.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 22 </td>
                                                    <td> Ashwini Shah </td>
                                                    <td> B.C.A., M.A. (Eng), B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 23 </td>
                                                    <td> Bhavna Arora </td>
                                                    <td> B.Sc, M.Sc, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 24 </td>
                                                    <td> Bhawna Negi </td>
                                                    <td> B.A./M.A.(Eco)/M.A. (Psy)/B.E.d </td>
                                                </tr>
                                                <tr>
                                                    <td> 25 </td>
                                                    <td> Bhawna Vijrai </td>
                                                    <td> B.A., B. Ed.,(Pursuing) </td>
                                                </tr>
                                                <tr>
                                                    <td> 26 </td>
                                                    <td> Chanchal Sharma </td>
                                                    <td> B.Sc., M.Sc., B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 27 </td>
                                                    <td> Charu Bhambri </td>
                                                    <td> BA, MA, GNIIT, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 28 </td>
                                                    <td> Charu Sharma </td>
                                                    <td> B.A./M.A./B.ED. </td>
                                                </tr>
                                                <tr>
                                                    <td> 29 </td>
                                                    <td> Deepa Sharma </td>
                                                    <td> BA,MA, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 30 </td>
                                                    <td> Deepak Agarwal </td>
                                                    <td> B.Sc, Grade A fron NIS, Diploma in Electronics Engineering
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td> 31 </td>
                                                    <td> Deepak Kumar </td>
                                                    <td> B.F.A./M.F.A. </td>
                                                </tr>
                                                <tr>
                                                    <td> 32 </td>
                                                    <td> Deepali Srivastava </td>
                                                    <td> B.SC, M.A, B.ED, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 33 </td>
                                                    <td> Deepankash Tyagi </td>
                                                    <td> BA,(Mus) MA (Music), Prabhakar, Visharad, Nipun </td>
                                                </tr>
                                                <tr>
                                                    <td> 34 </td>
                                                    <td> Devika Mehta </td>
                                                    <td> B.A/M.B.A/B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 35 </td>
                                                    <td> Diksha Batra </td>
                                                    <td> B.COM, B.ED, PGDM (FINANCE) </td>
                                                </tr>
                                                <tr>
                                                    <td> 36 </td>
                                                    <td> Dimple Gupta </td>
                                                    <td> B.Com, MMI Montessori, NIIT, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 37 </td>
                                                    <td> Dimple Sehrawat </td>
                                                    <td> B.Sc., M.Sc. (Pursuing), B.Ed., M.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 38 </td>
                                                    <td> Disha Agarwal </td>
                                                    <td> B.COM, Advanced Diploma in German, B2.2 GERMAN, </td>
                                                </tr>
                                                <tr>
                                                    <td> 39 </td>
                                                    <td> Divya Chadha </td>
                                                    <td> B.A./M.A./B.Ed./NPTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 40 </td>
                                                    <td> Divya Dutt </td>
                                                    <td> BBA, MA (Eng), B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 41 </td>
                                                    <td> Divya Rathore </td>
                                                    <td> BA, MA, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 42 </td>
                                                    <td> Divya Singh </td>
                                                    <td> BA, B.Ed, International certificate in Education for Pre
                                                        School proffessionals </td>
                                                </tr>
                                                <tr>
                                                    <td> 43 </td>
                                                    <td> Dr Shruti Gupta </td>
                                                    <td> B.Sc., M.Sc, B.Ed., Ph.D </td>
                                                </tr>
                                                <tr>
                                                    <td> 44 </td>
                                                    <td> Dr Smriti Kumar </td>
                                                    <td> B.Ed, BDS, PGD Hospital &amp; Healthcare Management, PGD in
                                                        Medico Legal Systems </td>
                                                </tr>
                                                <tr>
                                                    <td> 45 </td>
                                                    <td> Dr Suman Lata </td>
                                                    <td> B.A., M.A (Hindi, Sociology), B.Ed., M.Ed., M.Phil
                                                        (Sociology), Ph. D (Hindi) </td>
                                                </tr>
                                                <tr>
                                                    <td> 46 </td>
                                                    <td> Dr.Vinit Kakkar </td>
                                                    <td> B.Sc., M.Sc., B.Ed., Ph.D. </td>
                                                </tr>
                                                <tr>
                                                    <td> 47 </td>
                                                    <td> Ekta Jain </td>
                                                    <td> B.A., M.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 48 </td>
                                                    <td> Ekta Kapoor Anand </td>
                                                    <td> B.Sc.(Micro Bio.), MBA, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 49 </td>
                                                    <td> Engourai Newme </td>
                                                    <td> BA (Pol Sc), Grade 6 vocal, Grade 8 Guitar </td>
                                                </tr>
                                                <tr>
                                                    <td> 50 </td>
                                                    <td> Garima Bairagi </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 51 </td>
                                                    <td> Gauri Mankotia </td>
                                                    <td> B. Sc., M.Sc., B. Ed., M.Phil. </td>
                                                </tr>
                                                <tr>
                                                    <td> 52 </td>
                                                    <td> Gauri Saxena </td>
                                                    <td> B.A./M.B.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 53 </td>
                                                    <td> Gunjan Azmani </td>
                                                    <td> B.A., M.A. (Eng), B. Ed. , CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 54 </td>
                                                    <td> Gunjan Chadha </td>
                                                    <td> B.A(Pol Sc), M.A(Pol Sc), PDG Pre Primary Teachers
                                                        training, B.ED (Pursuing) </td>
                                                </tr>
                                                <tr>
                                                    <td> 55 </td>
                                                    <td> Harpreet Kaur </td>
                                                    <td> B.Sc, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 56 </td>
                                                    <td> Hina Naqvi </td>
                                                    <td> B.Sc, M.Sc, B.Ed, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 57 </td>
                                                    <td> Hunny </td>
                                                    <td> B.SC, B.P.ED, M.P.ED . </td>
                                                </tr>
                                                <tr>
                                                    <td> 58 </td>
                                                    <td> Inakshi Chaudhry </td>
                                                    <td> B.Com, M.Com, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 59 </td>
                                                    <td> Jagmeet Kaur </td>
                                                    <td> B. Tech./M. Tech./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 60 </td>
                                                    <td> Jolly Choudhary </td>
                                                    <td> B.A., M.A., B.Ed. , NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 61 </td>
                                                    <td> Jyoti Sharma </td>
                                                    <td> BBA, MBA, B.Ed., CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 62 </td>
                                                    <td> Jyoti Taneja (Gutt) </td>
                                                    <td> B.Com, M.Com, B.Ed, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 63 </td>
                                                    <td> Kaajal Negi </td>
                                                    <td> B. Com./B.F.A./N.T.T. </td>
                                                </tr>
                                                <tr>
                                                    <td> 64 </td>
                                                    <td> Kajingam Gangmei </td>
                                                    <td> BA (Sciology), Grade 6 Vocals </td>
                                                </tr>
                                                <tr>
                                                    <td> 65 </td>
                                                    <td> Kalpana Lohia </td>
                                                    <td> B.A/M.A./RCI </td>
                                                </tr>
                                                <tr>
                                                    <td> 66 </td>
                                                    <td> Kanchan Dhawan </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 67 </td>
                                                    <td> Kavita Rani </td>
                                                    <td> B.Sc, M.Sc, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 68 </td>
                                                    <td> Khushboo Sareen </td>
                                                    <td> B.Sc., M.Sc., B.Ed., CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 69 </td>
                                                    <td> Khushi Navani </td>
                                                    <td> B.Com., B.Ed, Dip in IT, Montessori &amp; Handicraft Teachers
                                                        Training Diploma </td>
                                                </tr>
                                                <tr>
                                                    <td> 70 </td>
                                                    <td> Kirti Hora </td>
                                                    <td> B. Com, M.Sc, B.Ed., CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 71 </td>
                                                    <td> Kirti Yadav </td>
                                                    <td> B.A./M.A./B.Ed./NTT/JBT </td>
                                                </tr>
                                                <tr>
                                                    <td> 72 </td>
                                                    <td> Komal Baheti </td>
                                                    <td> B.Com, M.A., M.Com., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 73 </td>
                                                    <td> Komal Rastogi </td>
                                                    <td> B.B.A., M.B.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 74 </td>
                                                    <td> Komal Sharma </td>
                                                    <td> BCA, MCA, DIP. in dance </td>
                                                </tr>
                                                <tr>
                                                    <td> 75 </td>
                                                    <td> Komal Sujeet </td>
                                                    <td> B.A(Pol Sc), M.A(Pol Sc), B.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 76 </td>
                                                    <td> Komal Taneja </td>
                                                    <td> B.Sc, M.Sc, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 77 </td>
                                                    <td> Kriti Khandelwal </td>
                                                    <td> B.A./M.A./B.Ed./CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 78 </td>
                                                    <td> Latika Goyal </td>
                                                    <td> B.F.A./M.F.A. </td>
                                                </tr>
                                                <tr>
                                                    <td> 79 </td>
                                                    <td> Leena Bhatia </td>
                                                    <td> BA, B.Ed, NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 80 </td>
                                                    <td> Lillian Joseph </td>
                                                    <td> B.A/M.A/B.ED./DIP. IN NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 81 </td>
                                                    <td> Madhvi Sharma (2) </td>
                                                    <td> B.A, M.A, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 82 </td>
                                                    <td> Madhvi Sharma-1 </td>
                                                    <td> BA, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 83 </td>
                                                    <td> Manan Kaur Oberoi </td>
                                                    <td> BA (Psy), Masters in Clinical Psychology, Fine Arts
                                                        Diploma, Art Therapy Advocate </td>
                                                </tr>
                                                <tr>
                                                    <td> 84 </td>
                                                    <td> Manisha </td>
                                                    <td> B.A./M.A./Dip. in Yoga </td>
                                                </tr>
                                                <tr>
                                                    <td> 85 </td>
                                                    <td> Meenakshi Solanki </td>
                                                    <td> B.A., M.A, B.Ed, M.PHILL </td>
                                                </tr>
                                                <tr>
                                                    <td> 86 </td>
                                                    <td> Meenal Tayal </td>
                                                    <td> B.Tech, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 87 </td>
                                                    <td> Mili Sodhi </td>
                                                    <td> B.A. (Hons)/B.Ed./PGDBM </td>
                                                </tr>
                                                <tr>
                                                    <td> 88 </td>
                                                    <td> Monica Chowdhry </td>
                                                    <td> B.SC/M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 89 </td>
                                                    <td> Monika Jasrotia </td>
                                                    <td> B.Sc (Zoo)., M.Sc. (Zoo), B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 90 </td>
                                                    <td> Muskaan Arora </td>
                                                    <td> B.Com./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 91 </td>
                                                    <td> Namita Breja </td>
                                                    <td> B.A(Eng), M.A(Eng), B.ED, M.Ed, Ph.D </td>
                                                </tr>
                                                <tr>
                                                    <td> 92 </td>
                                                    <td> Namita Chandra </td>
                                                    <td> B.Sc, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 93 </td>
                                                    <td> Navita Kaur Gill </td>
                                                    <td> BA (Eng), B.Ed, Junior Diploma in Kathak, Tabla, Senior
                                                        Diploma in Kathak </td>
                                                </tr>
                                                <tr>
                                                    <td> 94 </td>
                                                    <td> Navneet Chopra </td>
                                                    <td> B.A, M.A(Eng/Pol Sc), B.ED, M.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 95 </td>
                                                    <td> Navya </td>
                                                    <td> B.A., M.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 96 </td>
                                                    <td> Neha </td>
                                                    <td> B.A./C.C. in Swimming </td>
                                                </tr>
                                                <tr>
                                                    <td> 97 </td>
                                                    <td> Neha Agarwal </td>
                                                    <td> B.A./B.ED./ADV DIP IN TESOL/TEFL </td>
                                                </tr>
                                                <tr>
                                                    <td> 98 </td>
                                                    <td> Nidhi Dhingra Nayyar </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 99 </td>
                                                    <td> Nidhi Joshi </td>
                                                    <td> B. Tech./ B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 100 </td>
                                                    <td> Nidhi Mohan </td>
                                                    <td> BA (SOCIO), B.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 101 </td>
                                                    <td> Nidhi Sehgal </td>
                                                    <td> B.Com./M.Com./B.Ed./NTT/CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 102 </td>
                                                    <td> Nikita Kaur </td>
                                                    <td> B.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 103 </td>
                                                    <td> Nikita Sethi </td>
                                                    <td> B.A, Diploma in Commercial Arts and Multimedia </td>
                                                </tr>
                                                <tr>
                                                    <td> 104 </td>
                                                    <td> Nikita Vashisht </td>
                                                    <td> B.A./M.A./B.Ed./CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 105 </td>
                                                    <td> Nilakshi Chakraborty </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 106 </td>
                                                    <td> Nilisha Chhabra </td>
                                                    <td> B.Sc, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 107 </td>
                                                    <td> Nilofar Khan </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 108 </td>
                                                    <td> Nishat </td>
                                                    <td> B.Com, B.Ed, Diploma in Banking Administration, Master in
                                                        Marketing Management </td>
                                                </tr>
                                                <tr>
                                                    <td> 109 </td>
                                                    <td> Nupur Verma </td>
                                                    <td> B.A., M.A.(Eng),B.ED., NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 110 </td>
                                                    <td> Palak Narang </td>
                                                    <td> B.A(Eng), M.A(Eng), B.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 111 </td>
                                                    <td> Pallavi Gupta Bhalla </td>
                                                    <td> B.B.A./M.Com./Dip. in IB./Dip. in Management./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 112 </td>
                                                    <td> Payal Jain </td>
                                                    <td> B.Tech, M.Tech </td>
                                                </tr>
                                                <tr>
                                                    <td> 113 </td>
                                                    <td> Pooja Bakshi </td>
                                                    <td> B.Sc, MCA, G.NIIT, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 114 </td>
                                                    <td> Pooja Pandey </td>
                                                    <td> B.A., M.A., B.Ed. , NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 115 </td>
                                                    <td> Poornima Singh </td>
                                                    <td> B.Com, B.Ed, PGDCA, MCA </td>
                                                </tr>
                                                <tr>
                                                    <td> 116 </td>
                                                    <td> Pradipti Kapoor </td>
                                                    <td> B.A.(Hons), B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 117 </td>
                                                    <td> Prateeksha Pandey </td>
                                                    <td> B.Sc.(PCM), MA., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 118 </td>
                                                    <td> Pratima Rana </td>
                                                    <td> B.Sc, M.Sc, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 119 </td>
                                                    <td> Preety Bala </td>
                                                    <td> BCA, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 120 </td>
                                                    <td> Priyanka Gupta </td>
                                                    <td> B.Com, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 121 </td>
                                                    <td> Priyanka Kapoor </td>
                                                    <td> B.Com./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 122 </td>
                                                    <td> Priyanka Negi </td>
                                                    <td> B.Sc., M.Sc., B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 123 </td>
                                                    <td> Priyanka Sheorain </td>
                                                    <td> BA (Eng), MA (Eng), B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 124 </td>
                                                    <td> Priyanka Singh (I) </td>
                                                    <td> B.A./M.A.(FRN) </td>
                                                </tr>
                                                <tr>
                                                    <td> 125 </td>
                                                    <td> Priyanka Zulfikar </td>
                                                    <td> B.A, M.A, B.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 126 </td>
                                                    <td> Priyasha Bhansali </td>
                                                    <td> B.Sc., M.Sc., B.Ed., </td>
                                                </tr>
                                                <tr>
                                                    <td> 127 </td>
                                                    <td> Puneeta Bhalla </td>
                                                    <td> B.Com. (Hons) / (Non-B. Ed.) </td>
                                                </tr>
                                                <tr>
                                                    <td> 128 </td>
                                                    <td> Pushpa Devi </td>
                                                    <td> BA, B.Ed, MA (Hindi), CTET, HTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 129 </td>
                                                    <td> Rachita Kumar </td>
                                                    <td> B.Sc., M.Sc., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 130 </td>
                                                    <td> Rachna Mathur </td>
                                                    <td> B.Com, B.Ed., CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 131 </td>
                                                    <td> Rachna Sharma </td>
                                                    <td> BFA, Fashion/ Textile designing, DCCA </td>
                                                </tr>
                                                <tr>
                                                    <td> 132 </td>
                                                    <td> Rahul Kumar </td>
                                                    <td> B.COM, B.P.ED, M.P.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 133 </td>
                                                    <td> Rashmi Singh </td>
                                                    <td> B.Tech., D. El.Ed., Dip. in French </td>
                                                </tr>
                                                <tr>
                                                    <td> 134 </td>
                                                    <td> Reema Trivedi Misra </td>
                                                    <td> BA(Eng), MA(Eng), B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 135 </td>
                                                    <td> Reena Dalal </td>
                                                    <td> B.Sc, MA, B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 136 </td>
                                                    <td> Reeta Kumari </td>
                                                    <td> B.Sc., M.Sc., B.Ed., PGDCA </td>
                                                </tr>
                                                <tr>
                                                    <td> 137 </td>
                                                    <td> Reetu Raj </td>
                                                    <td> Prathama/Madhyama/Visharad </td>
                                                </tr>
                                                <tr>
                                                    <td> 138 </td>
                                                    <td> Rekha Rawat </td>
                                                    <td> BA, BP.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 139 </td>
                                                    <td> Reshma Kumari </td>
                                                    <td> B.Sc, M.Sc, B.Ed, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 140 </td>
                                                    <td> Richa Sharma </td>
                                                    <td> B.Com, M.Com, B.Ed, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 141 </td>
                                                    <td> Richa Tandon </td>
                                                    <td> B.Com, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 142 </td>
                                                    <td> Richa Taneja </td>
                                                    <td> B.Sc (PCM), MCA, PGDBM, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 143 </td>
                                                    <td> Ridhi Agarwal </td>
                                                    <td> B.COM, PGD YOGA EDUCATION </td>
                                                </tr>
                                                <tr>
                                                    <td> 144 </td>
                                                    <td> Ridhi Jain </td>
                                                    <td> B.A./M.A./B.Ed./CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 145 </td>
                                                    <td> Ridhima Rai </td>
                                                    <td> B.Com, B.Ed, PGDCC, PGDBA </td>
                                                </tr>
                                                <tr>
                                                    <td> 146 </td>
                                                    <td> Rifi Grover </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 147 </td>
                                                    <td> Ritu Jawa </td>
                                                    <td> BA, MA (Psy), B.Ed, NTT, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 148 </td>
                                                    <td> Ritu Mungee </td>
                                                    <td> B.Com, M.Com, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 149 </td>
                                                    <td> Ruchi Joshi </td>
                                                    <td> B.A., M.A, B.Ed, Certificate in Guidance </td>
                                                </tr>
                                                <tr>
                                                    <td> 150 </td>
                                                    <td> Ruchi Mehta (Visiting Faculty) </td>
                                                    <td> B.Sc, M.Sc, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 151 </td>
                                                    <td> Ruchi Singh (Visiting Faculty) Mon, Wed &amp; Fri </td>
                                                    <td> B.A(Eng), M.A(Eng), B.ED </td>
                                                </tr>
                                                <tr>
                                                    <td> 152 </td>
                                                    <td> Ruchika Trehan </td>
                                                    <td> BA (H. Math), B.ED, Dip. in Montessori Edn, M.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 153 </td>
                                                    <td> Rupali Bansal </td>
                                                    <td> B.Com./MBA./N.T.T. </td>
                                                </tr>
                                                <tr>
                                                    <td> 154 </td>
                                                    <td> Sachin Thakran </td>
                                                    <td> B.A., Dip. &amp; C. Course in Swimming </td>
                                                </tr>
                                                <tr>
                                                    <td> 155 </td>
                                                    <td> Saganpreet Kaur </td>
                                                    <td> B.Sc., M.Sc., B.ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 156 </td>
                                                    <td> Sakshi Garg </td>
                                                    <td> B.TECH, M.TECH </td>
                                                </tr>
                                                <tr>
                                                    <td> 157 </td>
                                                    <td> Sakshi Malhotra </td>
                                                    <td> BA (Psy), B.Ed, NTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 158 </td>
                                                    <td> Sameeksha Mishra </td>
                                                    <td> BA, B.Ed.,CTET, MA (Pursuing) </td>
                                                </tr>
                                                <tr>
                                                    <td> 159 </td>
                                                    <td> Samiksha Singh </td>
                                                    <td> B.A.(Prog), M.A.(Pol.Sc.) ,B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 160 </td>
                                                    <td> Samriti Bajaj </td>
                                                    <td> BIS., M.SC.(I.T.), MBA, Dip. in Elem. Edn. </td>
                                                </tr>
                                                <tr>
                                                    <td> 161 </td>
                                                    <td> Sangeeta Goyal </td>
                                                    <td> B.Sc, M.Sc, B.Ed, Ph. D (Psy) </td>
                                                </tr>
                                                <tr>
                                                    <td> 162 </td>
                                                    <td> Sanya Bhatia </td>
                                                    <td> BA, B.Ed, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 163 </td>
                                                    <td> Sapna Anand </td>
                                                    <td> BA, NTT, B.Ed, PGDBM </td>
                                                </tr>
                                                <tr>
                                                    <td> 164 </td>
                                                    <td> Sapna Tyagi </td>
                                                    <td> B.SC, MBA, PGDLT, CTET, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 165 </td>
                                                    <td> Sarita </td>
                                                    <td> B.F.A./M.F.A. </td>
                                                </tr>
                                                <tr>
                                                    <td> 166 </td>
                                                    <td> Sarwada Sandeep Sarin </td>
                                                    <td> B.Sc, B.Ed, PGDBA(HR)/ CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 167 </td>
                                                    <td> Shaily </td>
                                                    <td> B.Sc./M.A./B.Ed./M. Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 168 </td>
                                                    <td> Shalini Aneja </td>
                                                    <td> B.Sc, PGDBM, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 169 </td>
                                                    <td> Shalini Srivastava </td>
                                                    <td> BA, MA (Music) </td>
                                                </tr>
                                                <tr>
                                                    <td> 170 </td>
                                                    <td> Shalu </td>
                                                    <td> BA (Shastri), MA (Sanskrit), B.Ed.(Sanskrit), CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 171 </td>
                                                    <td> Sheetal Mahajan </td>
                                                    <td> B.Com, NTT, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 172 </td>
                                                    <td> Shefali Gupta </td>
                                                    <td> B.Sc, M.Sc, B.Ed, </td>
                                                </tr>
                                                <tr>
                                                    <td> 173 </td>
                                                    <td> Shipra Gulati </td>
                                                    <td> BA, MA (English), NTT, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 174 </td>
                                                    <td> Shivali Mahajan </td>
                                                    <td> B.Com./M.Com./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 175 </td>
                                                    <td> Shivani Saini </td>
                                                    <td> B.A./M.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 176 </td>
                                                    <td> Shivani Suneja </td>
                                                    <td> B.A, NPTT, DECE, CTET, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 177 </td>
                                                    <td> Shraddha Singh </td>
                                                    <td> B.A., MA., B.Ed., UGC Net, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 178 </td>
                                                    <td> Shubhangi Tiwari </td>
                                                    <td> B.A(Socio), M.A(Socio), B.ED, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 179 </td>
                                                    <td> Shweta Chandak </td>
                                                    <td> L.L.B., LLM, B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 180 </td>
                                                    <td> Shweta Singh </td>
                                                    <td> B.Sc./MBA/B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 181 </td>
                                                    <td> Sonica Sharma </td>
                                                    <td> B.Sc, M.Sc, PH.D, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 182 </td>
                                                    <td> Srishty Arora (P-T) </td>
                                                    <td> B.A./M.A./B.Ed./Dip. in German/CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 183 </td>
                                                    <td> Stuti Narendra Kumar Singh </td>
                                                    <td> B.A., M.A., B.Ed., M.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 184 </td>
                                                    <td> Stuti Sehgal </td>
                                                    <td> B.A. (Eng), M.A.(Eng), Dip. French </td>
                                                </tr>
                                                <tr>
                                                    <td> 185 </td>
                                                    <td> Sudhanshu Kumar </td>
                                                    <td> B.Com (H), B.P.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 186 </td>
                                                    <td> Sugandhi Aggarwal </td>
                                                    <td> B.A./B.Ed. /M.A. (Pursuing) </td>
                                                </tr>
                                                <tr>
                                                    <td> 187 </td>
                                                    <td> Sujata Jaiswal </td>
                                                    <td> B.E. (Non-B.Ed.) </td>
                                                </tr>
                                                <tr>
                                                    <td> 188 </td>
                                                    <td> Sujata Kapur (Visiting Faculty) </td>
                                                    <td> B.Sc, M.Sc, B.Ed., CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 189 </td>
                                                    <td> Sukoon Chopra </td>
                                                    <td> BA (H), B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 190 </td>
                                                    <td> Sumagna Banerjee </td>
                                                    <td> B.A., M.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 191 </td>
                                                    <td> Suman Lata Dahiya </td>
                                                    <td> BA, MA, B.Ed, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 192 </td>
                                                    <td> Sunil Kumar </td>
                                                    <td> BA, B.P.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 193 </td>
                                                    <td> Suparna Chakraborty </td>
                                                    <td> BA (Philosophy), Trained in Classical vocal, Diploma &amp;
                                                        Degree from Prayag Sangeeta Samiti </td>
                                                </tr>
                                                <tr>
                                                    <td> 194 </td>
                                                    <td> Surbhi Chaudhary </td>
                                                    <td> B.Sc., M.Sc., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 195 </td>
                                                    <td> Suruchi Ahuja </td>
                                                    <td> NTT, BA, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 196 </td>
                                                    <td> Swapna Malhotra </td>
                                                    <td> B.A./M.A./JR. &amp; SR. DIPLOMA </td>
                                                </tr>
                                                <tr>
                                                    <td> 197 </td>
                                                    <td> Swati Saxena </td>
                                                    <td> B.A., B.ED., M.ED. </td>
                                                </tr>
                                                <tr>
                                                    <td> 198 </td>
                                                    <td> T Wobeni Kikon </td>
                                                    <td> B.A., Dip in Music (Grade-8) </td>
                                                </tr>
                                                <tr>
                                                    <td> 199 </td>
                                                    <td> Tanvi Goel </td>
                                                    <td> B.ARCH./M.ES./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 200 </td>
                                                    <td> Tanya Koak </td>
                                                    <td> BA (Hon), M.A., B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 201 </td>
                                                    <td> Tanya Sharma </td>
                                                    <td> BA, B.Ed. M.A. (Pursuing) </td>
                                                </tr>
                                                <tr>
                                                    <td> 202 </td>
                                                    <td> Tina Joshi </td>
                                                    <td> BA, MA, B.Ed, NPTT </td>
                                                </tr>
                                                <tr>
                                                    <td> 203 </td>
                                                    <td> Tripti Tiwary Awasthi </td>
                                                    <td> BA, MA, Diploma in Mass Communication, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 204 </td>
                                                    <td> Upasana Gandha </td>
                                                    <td> BBA, MBA, B.Ed </td>
                                                </tr>
                                                <tr>
                                                    <td> 205 </td>
                                                    <td> Urvashi Thakur </td>
                                                    <td> B.Sc, M.Sc, B.Ed, M.Phill, CTET </td>
                                                </tr>
                                                <tr>
                                                    <td> 206 </td>
                                                    <td> Vaishali Saluja </td>
                                                    <td> B.Sc, M.Sc, B.Ed, CTET, CENTA </td>
                                                </tr>
                                                <tr>
                                                    <td> 207 </td>
                                                    <td> Vandana Payal </td>
                                                    <td> B.Sc., M.Sc., B.Ed., </td>
                                                </tr>
                                                <tr>
                                                    <td> 208 </td>
                                                    <td> Yogita Dagar </td>
                                                    <td> B.B.A./M.B.A./B.Ed. </td>
                                                </tr>
                                                <tr>
                                                    <td> 209 </td>
                                                    <td> Yogita Singh </td>
                                                    <td> M.Phil., M.P.Ed. , B.P.Ed, BA </td>
                                                </tr>



                                            </tbody></table>
                                    </div>


                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}
export default StaffDetails